import React, { useMemo } from 'react';

import { SelectableInfo } from '@vestahealthcare/common/enums/Enum';
import { translate } from '@vestahealthcare/common/i18n';
import { MemberWarningType } from '@vestahealthcare/common/models/member-warnings/MemberWarningType';

import { Select } from 'styleguide-v2';
import { Props as SelectProps } from 'styleguide-v2/src/components/Select/Props';

type Props = Omit<SelectProps, 'items' | 'onChange' | 'grouped'> & {
  items: SelectableInfo<MemberWarningType>[];
  onChange:
    | ((items: SelectableInfo<MemberWarningType>[]) => void)
    | ((item: SelectableInfo<MemberWarningType>) => void);
};

export const MemberWarningDropdown = ({ items, label, ...props }: Props) => {
  const sortedItems = useMemo(() => {
    const categories = Object.keys(
      items.reduce((acc, warningType) => {
        acc[warningType?.info?.category?.description || ''] = true;
        return acc;
      }, {} as { [key: string]: true }),
    ).sort();
    return items.sort(
      ({ info: a }, { info: b }) =>
        categories.indexOf(a?.category?.description || '') -
        categories.indexOf(b?.category?.description || ''),
    );
  }, [items]);

  return (
    <Select
      data-cy="filter-member-warning-dropdown"
      grouped={(warningType: SelectableInfo<MemberWarningType>) =>
        warningType?.info?.category?.description || ''
      }
      items={sortedItems}
      label={label || translate('components.MemberWarningDropdown.label')}
      {...props}
    />
  );
};
